const gtag = (sockObj) => {
  //console.log('gta event called');
  window.gtag('event', 'sockObj.eventName', {'send_to': sockObj.adwords_account});
}
export { gtag };